<template>
  <div>
    <load-profile />
    <n-search-container :fields="searchFields" @search="search" @reset="reset">
      <n-search-input ref="search" v-model="params" :fields="searchFields" />
    </n-search-container>

    <b-card no-body class="mb-0">
      <div class="p-2">
        <b-row>
          <b-col>
            <label>{{ $t('general.entries') }}</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
            >
              <template #no-options>
                {{ $t('selection.noOption') }}
              </template>
            </v-select>
          </b-col>
          <b-col
            v-if="
              $can('create', permissionType) &&
              userData.roleNames.includes('Super Admin')
            "
            class="text-right"
          >
            <b-button variant="primary" @click="goToCreate">{{
              $t('button.create')
            }}</b-button>
          </b-col>
        </b-row>
      </div>
      <div>
        <n-table
          ref="table"
          :fields="fields"
          :items="items"
          :busy="loading"
          :current-page="params.page"
          :per-page="$store.state.pagination.perPage"
          :total="total"
          :deletable="true"
          :updatable="false"
          :type="permissionType"
          :route="route"
          :check-is-default="true"
          @sort-changed="sortChanged"
          @destroy="destroy"
        >
          <template #cell(name)="data">
            <b-link class="link-hover" @click="goToTeam(data.item)">
              {{ getDepartmentName(data.item) }}
            </b-link>
          </template>
          <template #cell(workSchedule)="data">
            {{ getWorkScheduleName(data.item) }}
          </template>
          <template #cell(isActive)="data">
            <b-badge
              v-if="data.item.isActive"
              pill
              variant="success"
              badge-glow
            >
              {{ $t(`status.active`) }}
            </b-badge>
            <b-badge
              v-else-if="!data.item.isActive"
              pill
              variant="danger"
              badge-glow
            >
              {{ $t(`status.inactive`) }}
            </b-badge>
          </template>
          <template #front-button="data">
            <!-- <b-button
              v-b-tooltip.hover
              :title="$t('breadcrumb.serviceSystem')"
              variant="warning"
              pill
              size="sm"
              @click="goToServiceSystem(data.item)"
            >
              <feather-icon icon="ToolIcon" />
            </b-button> -->

            <b-button
              v-if="$can('manage', 'manage-employee')"
              v-b-tooltip.hover
              :title="$t('general.view')"
              variant="info"
              pill
              size="sm"
              @click="goToTeam(data.item)"
            >
              <feather-icon icon="UsersIcon" />
            </b-button>
            <b-button
              v-if="$can('manage', 'manage-employee') && !data.item.isDefault"
              v-b-tooltip.hover
              :title="$t('general.update')"
              variant="primary"
              pill
              size="sm"
              @click="goToUpdate(data.item)"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
            <b-button
              v-if="$can('manage', 'manage-employee') && data.item.isDefault"
              :style="{ cursor: 'not-allowed' }"
              v-b-tooltip.hover
              :title="$t('alert.cannotUpdateDefaultDepartment')"
              variant="secondary"
              pill
              size="sm"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
            <!-- <b-button
              v-if="$can('delete', 'manage-employee')"
              v-b-tooltip.hover
              :title="$t('general.delete')"
              variant="danger"
              pill
              size="sm"
              @click="confirmDestroy(data.item.id, data.index, data.item)"
            >
            ggggg
              <feather-icon icon="TrashIcon" />
            </b-button> -->
          </template>
        </n-table>
        <n-pagination
          class="mt-2"
          :total="total"
          :per-page="$store.state.pagination.perPage"
          :page="query.page"
          @change="list"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
  import {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BFormGroup,
    BInputGroup,
    BAvatar,
    BBadge,
    BLink,
    BSpinner
  } from 'bootstrap-vue';
  import vSelect from 'vue-select';
  import Repository from '@/repositories/RepositoryFactory';
  import NPagination from '@/components/NPagination';
  import NSearchContainer from '@/components/NSearchContainer';
  import NSearchInput from '@/components/NSearchInput';
  import NTable from '@/components/NTable';
  import { avatarText } from '@core/utils/filter';
  import useJwt from '@/auth/jwt/useJwt';
  import SearchInputs from './searchInput';
  import tableFields from './tableField';

  const DepartmentRepository = Repository.get('department');
  const ProjectRepository = Repository.get('project');

  export default {
    components: {
      BCard,
      BRow,
      BCol,
      BFormInput,
      BButton,
      BAvatar,
      BLink,
      BFormGroup,
      BInputGroup,
      BBadge,
      BSpinner,
      NPagination,
      NSearchInput,
      NSearchContainer,
      NTable,
      vSelect
    },

    data() {
      return {
        items: [],
        loading: false,
        resendLoading: false,
        total: 0,
        perPageOptions: this.$store.state.pagination.perPageOptions,
        params: {
          name: this.$route.query.name || null,
          email: this.$route.query.email || null,
          isActive: this.$route.query.isActive || null
        },
        query: {
          page: Number(this.$route.query.page) || 1,
          order: this.$route.query.order || null,
          sort: this.$route.query.sort || null,
          name: this.$route.query.name || null,
          isActive: this.$route.query.isActive || null
        },
        avatarText
      };
    },
    computed: {
      userData() {
        return this.$store.state.profile.email || this.$store.state.profile.phone
          ? this.$store.state.profile
          : JSON.parse(
              localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
            );
      },
      perPage: {
        get() {
          return this.$store.state.pagination.perPage;
        },
        set(value) {
          this.$store.commit('pagination/SET_PER_PAGE', value);
        }
      },
      activeSearch() {
        return !!this.$route.query.name || !!this.$route.query.isEnable;
      },
      locale() {
        return this.$i18n.locale.split('-')[0];
      }
    },
    watch: {
      perPage(value) {
        this.list(1);
      },
      '$route.params.projectId'(newVal) {
        if(!newVal) {
          this.getData();
        }
      }
    },
    mounted() {
      this.getData(this.query.page);
    },
    methods: {
      getDepartmentName(data) {
        let name = data?.name;
        if (typeof name === 'object') {
          name = name[this.locale] || name.en || name.zh || name.km || name.vn || '-';
        }
        return name || '-';
      },
      getWorkScheduleName(data) {
        let title = data.workSchedule.title;
        if (typeof title === 'object') {
          title = title[this.locale] || title.en || title.zh || title.km || title.vn || '-';
        }
        return title || '-';
      },
      updateQuerySting() {
        this.$router.replace({ query: this.query });
      },
      list(page = 1) {
        this.query.page = page;
        this.updateQuerySting();
        this.getData();
      },
      sortChanged(sortBy, sortDirection) {
        this.query.order = sortBy;
        this.query.sort = sortDirection;
        this.updateQuerySting();
        this.getData();
      },
      search() {
        this.query = {
          ...this.query,
          ...this.params
        };
        this.updateQuerySting();
        this.getData();
      },
      reset() {
        this.$refs.search.reset();
        this.query = {
          ...this.query,
          ...this.params
        };
        this.updateQuerySting();
        this.getData();
      },
      getData() {
        this.loading = true;
        DepartmentRepository.list({
          ...this.query,
          name: this.query.name?.trim() || null,
          projectId: this.$route.params.projectId || null
        })
          .then(response => {
            const data = response.data.data.list;
            this.items = [...data];
            this.total = response.data.data.total;
          })
          .catch(() => {})
          .finally(() => {
            this.loading = false;
          });
      },
      confirmDestroy(id, index, data) {
        index = this.$refs.table.calculateOrderNumber(index);
        this.$bvModal
          .msgBoxConfirm(
            this.$t('alert.unableToRevertAfterDelete', {
              item: `#${index} ${data.name?.[this.locale] || data?.name?.en || data?.name?.zh || data?.name?.km || data?.name?.vi || data.name || '-'}`,
            }),
            {
              title: this.$t('alert.confirmContinueOperation'),
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'danger',
              okTitle: this.$t('button.yesDelete'),
              cancelTitle: this.$t('button.cancel'),
              cancelVariant: 'outline-secondary',
              hideHeaderClose: false,
              centered: true
            }
          )
          .then(value => {
            if (value) {
              this.destroy(id);
            }
          });
      },
      destroy(id) {
        DepartmentRepository.destroy(id)
          .then(response => {
            this.getData();
          })
          .catch(error => {})
          .then(() => {
            this.loading = false;
          });
      },
      goToTeam(data) {
        if(this.$route.params.projectId) {
          this.$router.push({
            name: 'list-project-team',
            params: {
              projectId: this.$route.params.projectId,
              departmentId: data.id
            }
          });
        } else {
          this.$router.push({
            name: 'list-team',
            params: {
              departmentId: data.id
            }
          });
        }
      },
      goToServiceSystem(data) {
        this.$router.push({
          name: 'list-department-service-system',
          params: {
            departmentId: data.id
          }
        });
      },
      getProjectName(data) {
        if (this.$i18n.locale === 'vi') {
          return data?.name?.vi ? data?.name?.vi : data?.name?.en;
        }
        if (this.$i18n.locale === 'km') {
          return data?.name?.km ? data?.name?.km : data?.name?.en;
        }
        if (this.$i18n.locale === 'en') {
          return data?.name?.en ? data?.name?.en : data?.name?.zh;
        }
        return data?.name?.zh ? data?.name?.zh : data?.name?.en;
      },
      getProjects(projects) {
        if (!projects || !projects.length) {
          return '-'
        }

        return projects.map(project => this.getProjectName(project)).join('<br>')
      },
      goToCreate() {
        if (this.$route.params.projectId) {
          this.$router.push({
            name: 'create-project-department',
            params: {
              projectId: this.$route.params.projectId
            }
          });
        } else {
          this.$router.push({
            name: 'create-department'
          });
        }
      },
      goToUpdate(data) {
        if(this.$route.params.projectId) {
          this.$router.push({
            name: 'update-project-department',
            params: {
              projectId: this.$route.params.projectId,
              id: data.id
            }
          });
        } else {
          this.$router.push({
            name: 'update-department',
            params: {
              id: data.id
            }
          });
        }
      }
    },
    async beforeRouteEnter(to, from, next) {
      if (!to.params.projectId) {
        return next();
      }

      try {
        const response = await ProjectRepository.show(to.params.projectId);
        const data = response?.data?.data;
        if (!data || !data.id) {
          // If no data or invalid data, redirect back to department list
          return next({ name: 'list-project-department' });
        }

        const getProjectName = data => {
          const locale = localStorage.getItem('locale') || 'en';
          return data.name?.[locale] || data.name?.zh || data.name?.en || data.name?.km || data.name?.vi || ''
        };

        // Set breadcrumb if data exists
        to.meta.breadcrumb = [
          // {
          //   text: 'breadcrumb.listProject',
          //   to: { name: 'list-project' }
          // },
          {
            text: getProjectName(data),
            to: { name: 'list-project' }
          },
          {
            text: 'breadcrumb.list_department',
            active: true
          }
        ];

        next();
      } catch (error) {
        // Handle any errors by redirecting to department list
        console.error('Failed to fetch department:', error);
        next({ name: 'list-project' });
      }
    },
    setup() {
      const fields = tableFields;
      const searchFields = SearchInputs;
      const permissionType = 'manage-users';
      const route = 'department';

      return {
        fields,
        searchFields,
        permissionType,
        route
      };
    }
  };
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  .link-hover:hover {
    text-decoration: underline;
  }
</style>
